var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStudioManagement = function SvgStudioManagement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-940.000000, -790.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-Telefit",
    transform: "translate(920.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Telefit-List",
    transform: "translate(0.000000, 417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 7,
    transform: "translate(0.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left-Copy-4",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,7 L12,3 L2,3 L2,21 L22,21 L22,7 L12,7 L12,7 Z M6,11 L4,11 L4,9 L6,9 L6,11 L6,11 Z M6,7 L4,7 L4,5 L6,5 L6,7 L6,7 Z M10,11 L8,11 L8,9 L10,9 L10,11 L10,11 Z M10,7 L8,7 L8,5 L10,5 L10,7 L10,7 Z M20,19 L12,19 L12,17 L14,17 L14,15 L12,15 L12,13 L14,13 L14,11 L12,11 L12,9 L20,9 L20,19 L20,19 Z M18,11 L16,11 L16,13 L18,13 L18,11 L18,11 Z M18,15 L16,15 L16,17 L18,17 L18,15 L18,15 Z",
    id: "Shape",
    fill: "#F6F7FA"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStudioManagement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/studio-management.b9a7fccd.svg";
export { ForwardRef as ReactComponent };